<style>
.has-error {
  border-style: solid 3px red;
}

.no-error {
  background: green;
}
</style>

<template>
  <div class="container">
    <loading-component v-if="isLoading" />
    <no-result-component v-else-if="competition == null" />
    <div v-else>
      <page-title-component title="Vote" :subtitle="competition.name" />

      <section>
        <p>The voting is open until</p>
        <p></p>
        <p>{{ formatDateTime(competition.openTo) }}</p>
        <br />
        <div class="container" style="margin-left:10px; margin-right:10px">
          <div v-for="(competitionsClass, classIndex) in competition.classes" :key="competitionsClass.id"
            :id="'classDiv_' + classIndex" class="container" style="max-width:420px !important;">
            <div class="vote-class-card row">
              <div class="vote-class-card-header row" :class="competitionsClass.cssClass">
                <span>Class: {{ competitionsClass.name }}</span>
              </div>
              <div v-for="currentPlacing in competitionsClass.numberOfPlacings" :key="currentPlacing" class="row"
                style="margin-bottom:20px;">
                <b-field :label="getPlaceLabel(currentPlacing)">
                  <b-select placeholder="Select" icon="earth"
                    @input="validateClass(classIndex); removeVoteCountErrorMessage(classIndex)"
                    v-model="allPlacings[classIndex].placings[currentPlacing - 1]"
                    style="display:inline-block; max-width:340px">
                    <option value="00000000-0000-0000-0000-000000000000">Not assigned</option>
                    <option v-for="contestant in getContestantByClass(competitionsClass.id)" :value="contestant.id"
                      v-bind:key="contestant.id">{{ contestant.brewer + ' - ' + contestant.title }}</option>
                  </b-select>
                </b-field>
              </div>

              <b-field label type="is-danger" message="Only one vote per home brew is allowed!"
                :id="'classErrorMessage_' + classIndex"
                style="display:none; font-weight: bold; margin-top:10px; margin-bottom:10px;"></b-field>
              <b-field label type="is-danger" message="You must vote for each placing in a class!"
                :id="'classErrorMustVoteAllOrNoneMessage_' + classIndex"
                style="display:none; font-weight: bold; margin-top:10px; margin-bottom:10px;"></b-field>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="container" style="max-width:200px;">
          <b-field label="Keyword" :type="{ 'is-danger': errors.has('keyword') }" :message="errors.first('keyword')">
            <b-input v-model="keyword" name="keyword" v-validate="'required'" />
          </b-field>

          <div v-if="voteKey">
            <form v-on:submit.prevent="onSubmit">
              <div class="form-group" style="margin-bottom:20px">
                <b-button native-type="submit" class="button is-link" icon-left="vote">Place votes!</b-button>
              </div>
            </form>
          </div>
          <div v-else>
            <div class="form-group" style="margin-bottom:20px">
              <b-button native-type="submit" disabled="true" class="button is-link" icon-left="vote">Place votes!
              </b-button>
              <br />
              <p class="is-danger">You need to be logged in to place a vote. Follow the link in the e-mail</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import apiService from "./../services/apiService";
import LoadingComponent from "./Loading.vue";
import NoResultComponent from "./NoResult.vue";
import PageTitleComponent from "./PageTitle.vue";
var moment = require("moment");
moment().format();
export default {
  name: "Vote2",
  components: {
    LoadingComponent,
    NoResultComponent,
    PageTitleComponent
  },
  props: {
    competitionId: String,
    voteKey: String,
    visitorId: String
  },

  data() {
    return {
      numberOfPlacings: 3,
      isLoading: false,
      onlyCompetitionEntries: false,
      contestants: [],
      competition: null,
      allPlacings: [],
      keyword: null,
      firstPlace: null,
      secondPlace: null,
      thirdPlace: null
    };
  },
  async created() {
    this.isLoading = true;
    try {
      await this.fetchCompetitions();
      await this.fetchContestants();
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    getPlaceLabel(place) {
      var postfix = "e";
      var lastone = place
        .toString()
        .split("")
        .pop();

      if (lastone == "1") {
        postfix = "st";
      } else if (lastone == "2") {
        postfix = "nd";
      } else if (lastone == "3") {
        postfix = "d";
      } else {
        postfix = "th";
      }
      return place + ":" + postfix + " place";
    },

    removeVoteCountErrorMessage: function (classIndex) {
      //All ok
      document
        .getElementById("classDiv_" + classIndex)
        .classList.remove("has-error");
      document.getElementById(
        "classErrorMustVoteAllOrNoneMessage_" + classIndex
      ).style.display = "none";
      return true;
    },
    validateVoteCount: function (classIndex, numberOfPlacings) {
      var self = this;
      var votesInClass = self.allPlacings[classIndex].placings.filter(function (
        placing
      ) {
        return placing != "00000000-0000-0000-0000-000000000000";
      });

      if (votesInClass.length !== 0 && votesInClass.length != numberOfPlacings) {
        document
          .getElementById("classDiv_" + classIndex)
          .classList.add("has-error");
        document.getElementById(
          "classErrorMustVoteAllOrNoneMessage_" + classIndex
        ).style.display = "block";

        return false;

      } else {
        //All ok
        this.removeVoteCountErrorMessage(classIndex)

        return true;
      }

    },
    validateClass: function (classIndex) {
      var self = this;
      var votesInClass = self.allPlacings[classIndex].placings.filter(function (
        placing
      ) {
        return placing != "00000000-0000-0000-0000-000000000000";
      });

      if (votesInClass.length != new Set(votesInClass).size) {
        document
          .getElementById("classDiv_" + classIndex)
          .classList.add("has-error");
        document.getElementById(
          "classErrorMessage_" + classIndex
        ).style.display = "block";

        return false;
      }

      else {
        //All ok
        document
          .getElementById("classDiv_" + classIndex)
          .classList.remove("has-error");
        document.getElementById(
          "classErrorMessage_" + classIndex
        ).style.display = "none";

        return true;
      }
    },
    formatDateTime(datetime) {
      return moment(datetime).format("YYYY-MM-DD HH:mm:ss");
    },
    validateAllClasses: function () {
      var self = this;
      var allValid = true;
      for (var i = 0; i < self.competition.classes.length; i++) {
        if (!self.validateClass(i)) {
          allValid = false;
        }
      }
      return allValid;
    },

    validateAllVoteCounts: function () {
      var self = this;
      var allValid = true;
      for (var i = 0; i < self.competition.classes.length; i++) {
        if (!self.validateVoteCount(i, self.competition.classes[i].numberOfPlacings)) {
          allValid = false;
        }
      }
      return allValid;
    },
    onSubmit: function () {
      var self = this;

      if (!self.validateAllClasses()) {
        this.$toast.open({
          message: "Only one vote per home brew is allowed!",
          type: "is-danger",
          position: "is-bottom"
        });
        return;
      }

      if (!self.validateAllVoteCounts()) {
        this.$toast.open({
          message: "You must vote for each placing in a class!",
          type: "is-danger",
          position: "is-bottom"
        });
        return;
      }




      this.$validator.validateAll().then(result => {
        if (result) {
          var votePackageModel = {
            keyword: this.keyword,
            competitionId: this.competitionId,
            visitorId: this.visitorId,
            voteKey: this.voteKey,
            classVoteList: this.allPlacings
          };

          apiService
            .addVote(votePackageModel)
            .then(response => {
              this.$toast.open({
                message: "Thanks!",
                type: "is-success",
                position: "is-bottom"
              });
              self.$router.push({
                name: "voteconfirmed",
                params: { competitionId: this.competitionId }
              });
            })
            .catch(err => {
              this.$toast.open({
                message: err.response.data,
                type: "is-danger",
                position: "is-bottom"
              });
            });

          return;
        }

        this.$toast.open({
          message: "Your keyword is required!",
          type: "is-danger",
          position: "is-bottom"
        });
      });
    },

    async fetchCompetitions() {
      const competitionData = await apiService.getCompetition(
        this.competitionId
      );

      this.competition = competitionData.data;

      this.allPlacings = [[]];
      for (var i = 0; i < competitionData.data.classes.length; i++) {
        this.allPlacings[i] = {
          competitionClassId: competitionData.data.classes[i].id,
          placings: new Array(competitionData.data.classes[i].numberOfPlacings).fill(
            "00000000-0000-0000-0000-000000000000"
          )
        };
      }
    },
    getSeed() {
      return this.visitorId.charCodeAt(0) + this.visitorId.charCodeAt(1) + this.visitorId.charCodeAt(2) + this.visitorId.charCodeAt(3);
    },
    async fetchContestants() {
      const brewData = await apiService.getBrewsForCompetition(
        this.competitionId
      );

      this.contestants = this.shuffle(brewData.data, this.getSeed());
    },
    toggle(row) {
      this.$refs.table.toggleDetails(row);
    },
    getContestantByClass(classId) {
      return this.contestants.filter(function (c) {
        return c.competitionClassId === classId;
      });
    },

    shuffle(array, seed) {
      var m = array.length, t, i;
      let self = this;
      // While there remain elements to shuffle…
      while (m) {

        // Pick a remaining element…
        i = Math.floor(self.random(seed) * m--);

        // And swap it with the current element.
        t = array[m];
        array[m] = array[i];
        array[i] = t;
        ++seed
      }

      return array;
    },

    random(seed) {
      var x = Math.sin(seed++) * 10000;
      return x - Math.floor(x);
    }


  },
};
</script>
<style scoped>
div.vote-class-card {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #c5c5c5;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  -webkit-border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  width: 100%;
  border-radius: 10px 10px 10px 10px;
  display: table;
  overflow: hidden;
  margin-bottom: 20px;
}

div.vote-class-card-header {
  border-radius: 0px !important;
  font-size: 0.75rem;
  width: 100%;
  border-bottom: 1px solid rgba(136, 145, 144, 0.6);
  height: 34px;
  text-align: center;
  vertical-align: middle;
  margin-bottom: 20px;
}
</style>